import React, { useMemo, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const QuestionCard = (props) => {
  const {
    bgImg = null,
    bgImgDark = null,
    title,
    subtitle,
    lists = null,
    width = 500,
  } = props;
  const [defaultBg, setDefaultBg] = useState(true);
  return (
    <div
      className="question-card"
      style={{
        backgroundImage: defaultBg ? `url(${bgImg})` : `url(${bgImgDark})`,
        width: width,
      }}
      onMouseEnter={() => {
        setDefaultBg(false);
      }}
      onMouseLeave={() => {
        setDefaultBg(true);
      }}
    >
      <div>
        <div className="title">{title}</div>
        {subtitle && <div className="title">{subtitle}</div>}

        <div className="desc">
          {lists?.map((item) => (
            <li>{item}</li>
          ))}
        </div>
      </div>
    </div>
  );
};

export const ManufacturingQuestion = (props) => {
  const { t } = useTranslation();
  const text = useMemo(() => {
    return {
      title: t("finance.question.title"),
      cardOne: {
        width: 640,
        title: t("finance.question.cardOne.title"),

        lists: [
          t("finance.question.cardOne.descli1"),
          t("finance.question.cardOne.descli2"),
        ],
        bgImg: "https://files.authing.co/authing-website/manu-5-1-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-1-k.png",
      },
      cardTwo: {
        width: 530,
        title: t("finance.question.cardTwo.title"),
        lists: [
          t("finance.question.cardTwo.descli1"),
          t("finance.question.cardTwo.descli2"),
        ],
        bgImg: "https://files.authing.co/authing-website/manu-5-2-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-2-k.png",
      },
      cardThree: {
        width: 470,
        title: t("finance.question.cardThree.title"),
        lists: [
          t("finance.question.cardThree.descli1"),
          t("finance.question.cardThree.descli2"),
        ],
        bgImg: "https://files.authing.co/authing-website/manu-5-3-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-3-k.png",
      },
      cardFour: {
        width: 700,
        title: t("finance.question.cardFour.title"),
        lists: [
          t("finance.question.cardFour.descli1"),
          t("finance.question.cardFour.descli2"),
          t("finance.question.cardFour.descli3"),
        ],
        bgImg: "https://files.authing.co/authing-website/manu-5-4-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-4-k.png",
      },
    };
  }, [t]);

  return (
    <section className="finance-question">
      <h1 className="finance-title basic-title">{text.title}</h1>
      <div className="finance-question-content">
        <div className="content-main-top">
          <QuestionCard {...text.cardOne} />
          <QuestionCard {...text.cardTwo} />
        </div>
        <div className="content-main-bottom">
          <QuestionCard {...text.cardThree} />
          <QuestionCard {...text.cardFour} />
        </div>
      </div>
    </section>
  );
};
